export const TertiaryPackingRptConstants ={
    GETALL_REQUEST: 'TERTIARY_GETALL_REQUEST',
    GETALL_SUCCESS: 'TERTIARY_GETALL_SUCCESS',
    GETALL_FAILURE: 'TERTIARY_GETALL_FAILURE',

    GETEXPORT_REQUEST: 'TERTIARY_GETEXPORT_REQUEST',
    GETEXPORT_SUCCESS: 'TERTIARY_GETEXPORT_SUCCESS',
    GETEXPORT_FAILURE: 'TERTIARY_GETEXPORT_FAILURE',

    LOADING_REQUEST: 'LOADING_REQUEST'
}